let remountCallback = null;

const setRemountCallback = (callback) => {
    remountCallback = callback;
};

const remountApp = () => {
    if (remountCallback) {
        remountCallback();
    }
};

export { setRemountCallback, remountApp };
